import { useSelector } from "react-redux";
import { User } from "../../features/authentication/auth.model";
import { selectAuthenticatedUser } from "../../features/authentication/auth.selector";
import { Groups } from "../../features/authentication/authentication.constant";

export interface UseIsUserWithinGroups {
	isUserAuthorized: (groups: Groups[]) => boolean;
	isUserInGroupsExcluding: (
		includedGroups: Groups[],
		excludedGroups: Groups[]
	) => boolean;
}

export const useIsUserWithinGroups = (): UseIsUserWithinGroups => {
	const currentUser: User | undefined = useSelector(selectAuthenticatedUser);

	const hasAny = (groups: Groups[]) =>
		groups.some((g) => currentUser?.groups.includes(g));

	const isUserAuthorized = (groups: Groups[]) => hasAny(groups);

	const isUserInGroupsExcluding = (
		includedGroups: Groups[],
		excludedGroups: Groups[]
	) => hasAny(includedGroups) && !hasAny(excludedGroups);

	return {
		isUserAuthorized,
		isUserInGroupsExcluding,
	};
};
